import sectionToggler from '../../components/sectionToggler'

export const sectionsToggler = {
  components: {
    sectionToggler
  },
  methods: {
    toggleSec(tab) {

      this.activeSection = tab.tab;
      for (let i = 0; i < this.sections.length; i++) {
        this.sections[i].active = false
      }
      this.sections[tab.index].active = true;
    }
  }
}
